// src/services/api.ts
import axios from 'axios'
import { API_URL } from '../api/config'

const api = axios.create({
  baseURL: API_URL, // URL do seu backend
});

export default api;
